// source: talk-api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.talk_api.AssistantDefinition', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingRequest', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingResponse', null, global);
goog.exportSymbol('proto.talk_api.AssistantMessagingResponse.DataCase', null, global);
goog.exportSymbol('proto.talk_api.CreateConversationMetricRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateConversationMetricResponse', null, global);
goog.exportSymbol('proto.talk_api.CreateMessageMetricRequest', null, global);
goog.exportSymbol('proto.talk_api.CreateMessageMetricResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantDefinition.displayName = 'proto.talk_api.AssistantDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantMessagingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.AssistantMessagingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantMessagingRequest.displayName = 'proto.talk_api.AssistantMessagingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.AssistantMessagingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.AssistantMessagingResponse.oneofGroups_);
};
goog.inherits(proto.talk_api.AssistantMessagingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.AssistantMessagingResponse.displayName = 'proto.talk_api.AssistantMessagingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateMessageMetricRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateMessageMetricRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateMessageMetricRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateMessageMetricRequest.displayName = 'proto.talk_api.CreateMessageMetricRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateMessageMetricResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateMessageMetricResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateMessageMetricResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateMessageMetricResponse.displayName = 'proto.talk_api.CreateMessageMetricResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateConversationMetricRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateConversationMetricRequest.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateConversationMetricRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateConversationMetricRequest.displayName = 'proto.talk_api.CreateConversationMetricRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.CreateConversationMetricResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.CreateConversationMetricResponse.repeatedFields_, null);
};
goog.inherits(proto.talk_api.CreateConversationMetricResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.CreateConversationMetricResponse.displayName = 'proto.talk_api.CreateConversationMetricResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    version: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantDefinition;
  return proto.talk_api.AssistantDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.AssistantDefinition.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantDefinition} returns this
 */
proto.talk_api.AssistantDefinition.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.talk_api.AssistantDefinition.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantDefinition} returns this
 */
proto.talk_api.AssistantDefinition.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantMessagingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantMessagingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantMessagingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistant: (f = msg.getAssistant()) && proto.talk_api.AssistantDefinition.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && common_pb.Message.toObject(includeInstance, f),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    source: jspb.Message.getFieldWithDefault(msg, 7, 0),
    argsMap: (f = msg.getArgsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : [],
    optionsMap: (f = msg.getOptionsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Any.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantMessagingRequest}
 */
proto.talk_api.AssistantMessagingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantMessagingRequest;
  return proto.talk_api.AssistantMessagingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantMessagingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantMessagingRequest}
 */
proto.talk_api.AssistantMessagingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.talk_api.AssistantDefinition;
      reader.readMessage(value,proto.talk_api.AssistantDefinition.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 3:
      var value = new common_pb.Message;
      reader.readMessage(value,common_pb.Message.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 6:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 7:
      var value = /** @type {!proto.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 10:
      var value = msg.getArgsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    case 11:
      var value = msg.getOptionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Any.deserializeBinaryFromReader, "", new proto.google.protobuf.Any());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantMessagingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantMessagingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantMessagingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.talk_api.AssistantDefinition.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.Message.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getArgsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
  f = message.getOptionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Any.serializeBinaryToWriter);
  }
};


/**
 * optional AssistantDefinition assistant = 2;
 * @return {?proto.talk_api.AssistantDefinition}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.AssistantDefinition} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.AssistantDefinition, 2));
};


/**
 * @param {?proto.talk_api.AssistantDefinition|undefined} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
*/
proto.talk_api.AssistantMessagingRequest.prototype.setAssistant = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Message message = 3;
 * @return {?proto.Message}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getMessage = function() {
  return /** @type{?proto.Message} */ (
    jspb.Message.getWrapperField(this, common_pb.Message, 3));
};


/**
 * @param {?proto.Message|undefined} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
*/
proto.talk_api.AssistantMessagingRequest.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 assistantConversationId = 4;
 * @return {string}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearAssistantconversationid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingRequest.prototype.hasAssistantconversationid = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * map<string, google.protobuf.Any> metadata = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * optional Source source = 7;
 * @return {!proto.Source}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getSource = function() {
  return /** @type {!proto.Source} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Source} value
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * map<string, google.protobuf.Any> args = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getArgsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearArgsMap = function() {
  this.getArgsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Any> options = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Any>}
 */
proto.talk_api.AssistantMessagingRequest.prototype.getOptionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Any>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      proto.google.protobuf.Any));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.talk_api.AssistantMessagingRequest} returns this
 */
proto.talk_api.AssistantMessagingRequest.prototype.clearOptionsMap = function() {
  this.getOptionsMap().clear();
  return this;};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.AssistantMessagingResponse.oneofGroups_ = [[3,5]];

/**
 * @enum {number}
 */
proto.talk_api.AssistantMessagingResponse.DataCase = {
  DATA_NOT_SET: 0,
  MESSAGE: 3,
  EVENT: 5
};

/**
 * @return {proto.talk_api.AssistantMessagingResponse.DataCase}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getDataCase = function() {
  return /** @type {proto.talk_api.AssistantMessagingResponse.DataCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.AssistantMessagingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.AssistantMessagingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.AssistantMessagingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && common_pb.AssistantConversationMessage.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && common_pb.Event.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.AssistantMessagingResponse}
 */
proto.talk_api.AssistantMessagingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.AssistantMessagingResponse;
  return proto.talk_api.AssistantMessagingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.AssistantMessagingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.AssistantMessagingResponse}
 */
proto.talk_api.AssistantMessagingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 3:
      var value = new common_pb.AssistantConversationMessage;
      reader.readMessage(value,common_pb.AssistantConversationMessage.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 5:
      var value = new common_pb.Event;
      reader.readMessage(value,common_pb.Event.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.AssistantMessagingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.AssistantMessagingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.AssistantMessagingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.AssistantMessagingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common_pb.AssistantConversationMessage.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Event.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AssistantConversationMessage message = 3;
 * @return {?proto.AssistantConversationMessage}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getMessage = function() {
  return /** @type{?proto.AssistantConversationMessage} */ (
    jspb.Message.getWrapperField(this, common_pb.AssistantConversationMessage, 3));
};


/**
 * @param {?proto.AssistantConversationMessage|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Event event = 5;
 * @return {?proto.Event}
 */
proto.talk_api.AssistantMessagingResponse.prototype.getEvent = function() {
  return /** @type{?proto.Event} */ (
    jspb.Message.getWrapperField(this, common_pb.Event, 5));
};


/**
 * @param {?proto.Event|undefined} value
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
*/
proto.talk_api.AssistantMessagingResponse.prototype.setEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.talk_api.AssistantMessagingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.AssistantMessagingResponse} returns this
 */
proto.talk_api.AssistantMessagingResponse.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.AssistantMessagingResponse.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateMessageMetricRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateMessageMetricRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateMessageMetricRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    messageid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateMessageMetricRequest}
 */
proto.talk_api.CreateMessageMetricRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateMessageMetricRequest;
  return proto.talk_api.CreateMessageMetricRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateMessageMetricRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateMessageMetricRequest}
 */
proto.talk_api.CreateMessageMetricRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessageid(value);
      break;
    case 4:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateMessageMetricRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateMessageMetricRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMessageid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantConversationId = 2;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string messageId = 3;
 * @return {string}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getMessageid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.setMessageid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated Metric metrics = 4;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 4));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
*/
proto.talk_api.CreateMessageMetricRequest.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateMessageMetricRequest.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateMessageMetricRequest} returns this
 */
proto.talk_api.CreateMessageMetricRequest.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateMessageMetricResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateMessageMetricResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateMessageMetricResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Metric.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateMessageMetricResponse}
 */
proto.talk_api.CreateMessageMetricResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateMessageMetricResponse;
  return proto.talk_api.CreateMessageMetricResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateMessageMetricResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateMessageMetricResponse}
 */
proto.talk_api.CreateMessageMetricResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateMessageMetricResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateMessageMetricResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateMessageMetricResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Metric data = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
*/
proto.talk_api.CreateMessageMetricResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
*/
proto.talk_api.CreateMessageMetricResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateMessageMetricResponse} returns this
 */
proto.talk_api.CreateMessageMetricResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateMessageMetricResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateConversationMetricRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateConversationMetricRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateConversationMetricRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantconversationid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    metricsList: jspb.Message.toObjectList(msg.getMetricsList(),
    common_pb.Metric.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateConversationMetricRequest}
 */
proto.talk_api.CreateConversationMetricRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateConversationMetricRequest;
  return proto.talk_api.CreateConversationMetricRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateConversationMetricRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateConversationMetricRequest}
 */
proto.talk_api.CreateConversationMetricRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantconversationid(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addMetrics(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateConversationMetricRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateConversationMetricRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantconversationid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getMetricsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantConversationId = 2;
 * @return {string}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getAssistantconversationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.setAssistantconversationid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * repeated Metric metrics = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.getMetricsList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
*/
proto.talk_api.CreateConversationMetricRequest.prototype.setMetricsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateConversationMetricRequest.prototype.addMetrics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateConversationMetricRequest} returns this
 */
proto.talk_api.CreateConversationMetricRequest.prototype.clearMetricsList = function() {
  return this.setMetricsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.CreateConversationMetricResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.CreateConversationMetricResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.CreateConversationMetricResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    common_pb.Metric.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.CreateConversationMetricResponse}
 */
proto.talk_api.CreateConversationMetricResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.CreateConversationMetricResponse;
  return proto.talk_api.CreateConversationMetricResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.CreateConversationMetricResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.CreateConversationMetricResponse}
 */
proto.talk_api.CreateConversationMetricResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new common_pb.Metric;
      reader.readMessage(value,common_pb.Metric.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.CreateConversationMetricResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.CreateConversationMetricResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.CreateConversationMetricResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metric.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated Metric data = 3;
 * @return {!Array<!proto.Metric>}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.Metric>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metric, 3));
};


/**
 * @param {!Array<!proto.Metric>} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
*/
proto.talk_api.CreateConversationMetricResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metric=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metric}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metric, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
*/
proto.talk_api.CreateConversationMetricResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.CreateConversationMetricResponse} returns this
 */
proto.talk_api.CreateConversationMetricResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.CreateConversationMetricResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.talk_api);
